module.exports = __webpack_public_path__ + "static/scale-model-of-n-c-travel-in-fayetteville-north-carolina-a63069936dedeca75f8b535e4f494b59.png";